import * as i18n from "../common/i18n";

export const EventCode = {
    "FLUSH": i18n.get("events.code.FLUSH"),
    "RESET": i18n.get("events.code.RESET"),
    "RESTART": i18n.get("events.code.RESTART"),
    "DUMP": i18n.get("events.code.DUMP"),
    "UPDATE": i18n.get("events.code.UPDATE"),
    "PAIR": i18n.get("events.code.PAIR"),
    "DISTANCE_ERROR": i18n.get("events.code.DISTANCE_ERROR"),
    "FLOW_ERROR": i18n.get("events.code.FLOW_ERROR"),
    "OUTOFBOUNDS_ERROR": i18n.get("events.code.OUTOFBOUNDS_ERROR"),
    "BATTERY_LOW": i18n.get("events.code.BATTERY_LOW"),
    "NETWORK_ERROR": i18n.get("events.code.NETWORK_ERROR"),
    "SERVER_ERROR": i18n.get("events.code.SERVER_ERROR"),
    "UPDATE_ERROR": i18n.get("events.code.UPDATE_ERROR"),
    "GENERAL_ERROR": i18n.get("events.code.GENERAL_ERROR"),
    "SENSOR_ERROR_FLOW": i18n.get("events.code.SENSOR_ERROR_FLOW"),
    "INBOUND_TEMPERATURE": i18n.get("events.code.INBOUND_TEMPERATURE"),
    "SENSOR_ERROR_DISTANCE": i18n.get("events.code.SENSOR_ERROR_DISTANCE"),
    "SENSOR_ERROR_TEMPERATURE": i18n.get("events.code.SENSOR_ERROR_TEMPERATURE"),
    "VALVE_ERROR": i18n.get("events.code.VALVE_ERROR"),
}

export const AlertStatus = {
    "NEW": i18n.get("alerts.status.new"),
    "DONE": i18n.get("alerts.status.done")
}

export const AlertCause = {
    "BATTERY_LOW": i18n.get("events.code.BATTERY_LOW"),
    "VALVE_ERROR": i18n.get("events.code.VALVE_ERROR"),
    "SENSOR_ERROR_FLOW": i18n.get("events.code.SENSOR_ERROR_FLOW"),
}

export const suggestedEventCodes = [
    {
        value: "FLUSH",
        name: i18n.get("events.code.FLUSH")
    },
    {
        value: "RESET",
        name: i18n.get("events.code.RESET")
    },
    {
        value: "RESTART",
        name: i18n.get("events.code.RESTART")
    },
    {
        value: "DUMP",
        name: i18n.get("events.code.DUMP")
    },
    {
        value: "UPDATE",
        name: i18n.get("events.code.UPDATE")
    },
    {
        value: "PAIR",
        name: i18n.get("events.code.PAIR")
    },
    {
        value: "DISTANCE_ERROR",
        name: i18n.get("events.code.DISTANCE_ERROR")
    },
    {
        value: "FLOW_ERROR",
        name: i18n.get("events.code.FLOW_ERROR")
    },
    {
        value: "OUTOFBOUNDS_ERROR",
        name: i18n.get("events.code.OUTOFBOUNDS_ERROR")
    },
    {
        value: "BATTERY_LOW",
        name: i18n.get("events.code.BATTERY_LOW")
    },
    {
        value: "NETWORK_ERROR",
        name: i18n.get("events.code.NETWORK_ERROR")
    },
    {
        value: "SERVER_ERROR",
        name: i18n.get("events.code.SERVER_ERROR")
    },
    {
        value: "UPDATE_ERROR",
        name: i18n.get("events.code.UPDATE_ERROR")
    },
    {
        value: "GENERAL_ERROR",
        name: i18n.get("events.code.GENERAL_ERROR")
    },
    {
        value: "SENSOR_ERROR_FLOW",
        name: i18n.get("events.code.SENSOR_ERROR_FLOW")
    },
    {
        value: "INBOUND_TEMPERATURE",
        name: i18n.get("events.code.INBOUND_TEMPERATURE")
    },
    {
        value: "SENSOR_ERROR_DISTANCE",
        name: i18n.get("events.code.SENSOR_ERROR_DISTANCE")
    },
    {
        value: "SENSOR_ERROR_TEMPERATURE",
        name: i18n.get("events.code.SENSOR_ERROR_TEMPERATURE")
    },
    {
        value: "VALVE_ERROR",
        name: i18n.get("events.code.VALVE_ERROR")
    }
]
